import styles from "./styles";
import { VeryInput } from "../common/v2/VeryInput";
import { VeryInputTel } from "../common/v2/VeryInputTel";
import { useState, useEffect } from "react";
import { classVeryInput } from "../common/v2/VeryInput/classVeryInput";
import {
  isArrayEmpty,
  isPositiveInt,
  isStringEmpty,
} from "../../utils/handler_validations";
import SelectYear from "./SelectYear";
import SelectColor from "./SelectColor";
import { useFormDriverContext } from "../../context/formDriver.context";
import { VeryPickerImgPdf } from "../common/v2/VeryPickerImgPdf";
import SelectAirbag from "./SelectAirbags";
import ABSCheckbox from "./ABSCheckBox";
import { VeryIconGoogle } from "../common/v2/VeryIconGoogle";
import { classVeryIconGoogle } from "../common/v2/VeryIconGoogle/classVeryIconGoogle";

const propsTemplate = () => ({
  CSS: [],
});

const ModalDriver = (props = propsTemplate()) => {
  const formDriver = useFormDriverContext();
  const customCSS = ["ModalAddDriver"];

  if (!isArrayEmpty(props.CSS)) customCSS.push(props.CSS.join(" "));
  if (!isStringEmpty(props.className)) customCSS.push(props.className);

  return (
    <styles.DivMain
      CSS={customCSS}
      isVisible={formDriver.value.show}
      title={
        formDriver.value.modeEdit ? "Editar conductor" : "Registrar conductor"
      }
      btnMain={{
        label: formDriver.value.modeEdit
          ? "Editar conductor"
          : "Registrar conductor",
        isLoading: formDriver.value.loading,
        onClick: () => formDriver.onClickBtnMain(),
      }}
      stepSelected={formDriver.value.stepSelected}
      onClickBtnClose={() => formDriver.hideModal()}
      onChangeStepSelected={(newStep) => formDriver.updateStep(newStep)}
      steps={Object.values(formDriver.steps)}
    >
      {/* RESTORED DRAFT NOTICE */}
      {!formDriver.value.modeEdit && formDriver.hasDraft && (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "4px 10px",
            backgroundColor: "#eff6ff",
            border: "1px solid #bfdbfe",
            borderRadius: "6px",
            marginBottom: "6px",
            fontSize: "11px",
            color: "#1e40af",
            boxSizing: "border-box",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <VeryIconGoogle
              name="history"
              type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
              size={14}
              color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
            />
            <span>
              <strong>Borrador recuperado:</strong> Se precargaron los datos guardados de tu sesión previa.
            </span>
          </div>
          <button
            type="button"
            onClick={() => formDriver.clearDraft()}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
              background: "#ffffff",
              border: "1px solid #fca5a5",
              borderRadius: "4px",
              padding: "2px 6px",
              fontSize: "10px",
              fontWeight: "600",
              color: "#dc2626",
              cursor: "pointer",
            }}
          >
            <VeryIconGoogle
              name="delete_outline"
              type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
              size={12}
              color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
            />
            Limpiar datos
          </button>
        </div>
      )}

      {/* PANEL PERSONAL DATA */}
      <styles.PanelPersonal isActiveStep={formDriver.value.stepSelected === 0}>
        {/* PICKER IMG PROFILE */}
        <VeryPickerImgPdf
          key={`profileImg-${formDriver.pickerResetKey}`}
          title={"Fotografía del conductor"}
          isRequired
          disabledImgs={false}
          disabledPdfs={true}
          error={formDriver.errorData.profileImg}
          originalFile={formDriver.originalData.profileImg}
          file={formDriver.data.profileImg}
          onChangeFile={(selectedFile) => {
            formDriver.updateData({ profileImg: selectedFile });
          }}
          onError={(msgError) => {
            formDriver.updateErrorsData({ profileImg: msgError });
          }}
        />
        {/* INPUT NAME + LASTNAME */}
        <div className="divName">
          <VeryInput
            CSS={["divInputName"]}
            isEditable
            isRequired
            placeHolder="Ingresa el nombre"
            text={formDriver.data.name}
            textError={formDriver.errorData.name}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="Nombre"
            onChangeText={(newText) => formDriver.updateData({ name: newText })}
          />
          <VeryInput
            CSS={["divInputLastName"]}
            isEditable
            isRequired
            placeHolder="Ingresa los apellidos"
            text={formDriver.data.lastName}
            textError={formDriver.errorData.lastName}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="Apellidos"
            onChangeText={(newText) =>
              formDriver.updateData({ lastName: newText })
            }
          />
        </div>
        {/* INPUT EMAIL */}
        <VeryInput
          CSS={["divInputEmail"]}
          isEditable={!formDriver.value.modeEdit}
          isRequired={!formDriver.value.modeEdit}
          placeHolder="Ingresa el correo"
          text={formDriver.data.email}
          textError={formDriver.errorData.email}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Correo electrónico"
          onChangeText={(newText) => {
            formDriver.updateData({ email: newText });
          }}
        />
        {/* INPUT TEL */}
        <VeryInputTel
          CSS={["divInputTel"]}
          isEditable={!formDriver.value.modeEdit}
          isRequired={!formDriver.value.modeEdit}
          text={formDriver.data.tel}
          textError={formDriver.errorData.tel}
          onChangeText={(newText) => {
            formDriver.updateData({ tel: newText });
          }}
        />
        {/* INPUT CURP */}
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 4 }}>
          <VeryInput
            CSS={["divInputCurp"]}
            isEditable
            isRequired={!formDriver.value.modeEdit}
            placeHolder="Ingresa la CURP (18 caracteres)"
            text={formDriver.data.curp}
            textError={formDriver.curpStatus.isDuplicate ? "" : formDriver.errorData.curp}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="CURP"
            onChangeText={(newText) => {
              formDriver.updateData({ curp: newText.toUpperCase().trim() });
            }}
          />
          {/* CURP LIVE STATUS BADGE */}
          {formDriver.curpStatus.checking && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#2563eb", marginTop: -2, paddingLeft: 4 }}>
              <VeryIconGoogle
                name="sync"
                enabledSpin
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
              />
              <span>{formDriver.curpStatus.message}</span>
            </div>
          )}
          {formDriver.curpStatus.isValid && !formDriver.curpStatus.checking && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#16a34a", marginTop: -2, paddingLeft: 4, fontWeight: "600" }}>
              <VeryIconGoogle
                name="check_circle"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.GREEN_S1}
              />
              <span>{formDriver.curpStatus.message}</span>
            </div>
          )}
          {formDriver.curpStatus.isDuplicate && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#dc2626", marginTop: -2, paddingLeft: 4, fontWeight: "600" }}>
              <VeryIconGoogle
                name="cancel"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
              />
              <span>{formDriver.curpStatus.message}</span>
            </div>
          )}
        </div>
      </styles.PanelPersonal>

      {/* PANEL VEHICLE DATA */}
      <styles.PanelVehicle isActiveStep={formDriver.value.stepSelected === 1}>
        {/* INPUT MODEL */}
        <VeryInput
          CSS={["divinputModel"]}
          isEditable
          isRequired
          placeHolder="Ingresa la marca y modelo del auto"
          text={formDriver.data.vehicleModel}
          textError={formDriver.errorData.vehicleModel}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Marca / Modelo"
          onChangeText={(newText) => {
            formDriver.updateData({ vehicleModel: newText });
          }}
        />
        {/* SELECT YEAR + SELECT COLOR */}
        <div className="divSelects">
          <SelectYear
            textError={formDriver.errorData.vehicleYear}
            selectedYear={formDriver.data.vehicleYear}
            onChangeYear={(newYear) => {
              formDriver.updateData({ vehicleYear: newYear });
            }}
          />
          <SelectColor
            textError={formDriver.errorData.vehicleColor}
            selectedValue={formDriver.data.vehicleColor}
            onChangeValue={(newValue) => {
              formDriver.updateData({ vehicleColor: newValue });
            }}
          />
        </div>
        {/* SELECT AIRBAGS + ABS */}
        <div className="divSelects">
          <SelectAirbag
            textError={formDriver.errorData.vehicleAirbags}
            selectedVehicleAirbags={formDriver.data.vehicleAirbags}
            onChangeVehicleAirbags={(newAirbag) => {
              formDriver.updateData({ vehicleAirbags: newAirbag });
            }}
          />
          <ABSCheckbox
            title="Sistema de frenos"
            textError={formDriver.errorData.vehicleABS}
            hasABS={formDriver.data.vehicleABS}
            onChangeABS={(newABS) => {
              formDriver.updateData({ vehicleABS: newABS });
            }}
          />
        </div>
        {/* INPUT PLATES */}
        <VeryInput
          CSS={["divInputPlates"]}
          isEditable
          isRequired
          placeHolder="Ingresa las placas del auto"
          text={formDriver.data.vehiclePlates}
          textError={formDriver.errorData.vehiclePlates}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Placas"
          onChangeText={(newText) => {
            formDriver.updateData({ vehiclePlates: newText.toUpperCase() });
          }}
        />
        {/* INPUT SERIAL NUMBER / VIN */}
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 4 }}>
          <VeryInput
            CSS={["divInputVin"]}
            isEditable
            isRequired={!formDriver.value.modeEdit}
            placeHolder="Ingresa el número de serie / VIN (17 caracteres)"
            text={formDriver.data.vehicleSerialNumber}
            textError={formDriver.vinStatus.isDuplicate ? "" : formDriver.errorData.vehicleSerialNumber}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="Número de serie / VIN"
            onChangeText={(newText) => {
              formDriver.updateData({
                vehicleSerialNumber: newText.toUpperCase().trim(),
              });
            }}
          />
          {/* VIN LIVE STATUS BADGE */}
          {formDriver.vinStatus.checking && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#2563eb", marginTop: -2, paddingLeft: 4 }}>
              <VeryIconGoogle
                name="sync"
                enabledSpin
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
              />
              <span>{formDriver.vinStatus.message}</span>
            </div>
          )}
          {formDriver.vinStatus.isValid && !formDriver.vinStatus.checking && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#16a34a", marginTop: -2, paddingLeft: 4, fontWeight: "600" }}>
              <VeryIconGoogle
                name="check_circle"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.GREEN_S1}
              />
              <span>{formDriver.vinStatus.message}</span>
            </div>
          )}
          {formDriver.vinStatus.isDuplicate && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#dc2626", marginTop: -2, paddingLeft: 4, fontWeight: "600" }}>
              <VeryIconGoogle
                name="cancel"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={14}
                color={classVeryIconGoogle.ICON_COLOR.BLACK_S1}
              />
              <span>{formDriver.vinStatus.message}</span>
            </div>
          )}
        </div>

        {/* SERVICIOS AUTORIZADOS */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginTop: 4,
          }}
        >
          <label style={{ fontSize: 13, fontWeight: "700", color: "#13131d" }}>
            Servicios Autorizados *
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 16,
              flexWrap: "wrap",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                padding: "8px 14px",
                borderRadius: 8,
                border: formDriver.data.allowsTrips
                  ? "1.5px solid #00a859"
                  : "1px solid #d1d5db",
                backgroundColor: formDriver.data.allowsTrips
                  ? "#f0fdf4"
                  : "#ffffff",
                fontSize: 13,
                fontWeight: "600",
                color: formDriver.data.allowsTrips ? "#166534" : "#4b5563",
                transition: "all 0.2s ease",
              }}
            >
              <input
                type="checkbox"
                checked={formDriver.data.allowsTrips}
                onChange={(e) => {
                  formDriver.updateData({ allowsTrips: e.target.checked });
                }}
                style={{ accentColor: "#00a859", width: 16, height: 16 }}
              />
              <VeryIconGoogle
                name="local_taxi"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={18}
                color={formDriver.data.allowsTrips ? classVeryIconGoogle.ICON_COLOR.GREEN_S1 : classVeryIconGoogle.ICON_COLOR.GRAY_S1}
              />
              <span>Viajes de Pasajeros (Taxi)</span>
            </label>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                padding: "8px 14px",
                borderRadius: 8,
                border: formDriver.data.allowsShipments
                  ? "1.5px solid #0284c7"
                  : "1px solid #d1d5db",
                backgroundColor: formDriver.data.allowsShipments
                  ? "#f0f9ff"
                  : "#ffffff",
                fontSize: 13,
                fontWeight: "600",
                color: formDriver.data.allowsShipments ? "#0369a1" : "#4b5563",
                transition: "all 0.2s ease",
              }}
            >
              <input
                type="checkbox"
                checked={formDriver.data.allowsShipments}
                onChange={(e) => {
                  formDriver.updateData({ allowsShipments: e.target.checked });
                }}
                style={{ accentColor: "#0284c7", width: 16, height: 16 }}
              />
              <VeryIconGoogle
                name="inventory_2"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={18}
                color={formDriver.data.allowsShipments ? classVeryIconGoogle.ICON_COLOR.BLACK_S1 : classVeryIconGoogle.ICON_COLOR.GRAY_S1}
              />
              <span>Envíos y Paquetería</span>
            </label>
          </div>
          {formDriver.errorData.allowedServices ? (
            <span style={{ fontSize: 11, color: "#ef4444", marginTop: 2 }}>
              {formDriver.errorData.allowedServices}
            </span>
          ) : null}
        </div>

        {/* PICKER IMG VEHICLE */}
        <div className="divPhotos">
          <span className="spanText">Fotos del vehículo</span>
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              key={`vehicleFrontPhoto-${formDriver.pickerResetKey}`}
              title={"Foto frontal"}
              isRequired
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleFrontPhoto}
              originalFile={formDriver.originalData.vehicleFrontPhoto}
              file={formDriver.data.vehicleFrontPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleFrontPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleFrontPhoto: msgError });
              }}
            />
            <VeryPickerImgPdf
              key={`vehicleBackPhoto-${formDriver.pickerResetKey}`}
              title={"Foto trasera"}
              isRequired
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleBackPhoto}
              originalFile={formDriver.originalData.vehicleBackPhoto}
              file={formDriver.data.vehicleBackPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleBackPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleBackPhoto: msgError });
              }}
            />
          </div>
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              key={`vehicleLeftPhoto-${formDriver.pickerResetKey}`}
              title={"Foto lateral izquierda"}
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleLeftPhoto}
              originalFile={formDriver.originalData.vehicleLeftPhoto}
              file={formDriver.data.vehicleLeftPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleLeftPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleLeftPhoto: msgError });
              }}
            />
            <VeryPickerImgPdf
              key={`vehicleRightPhoto-${formDriver.pickerResetKey}`}
              title={"Foto lateral derecha"}
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleRightPhoto}
              originalFile={formDriver.originalData.vehicleRightPhoto}
              file={formDriver.data.vehicleRightPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleRightPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleRightPhoto: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelVehicle>

      {/* PANEL DOCUMENTS */}
      <styles.PanelDocumentsVehicle
        isActiveStep={formDriver.value.stepSelected === 2}
      >
        {/* WARNING TEXT */}
        <label className="txtWarning">
          Por cuestiones de seguridad para todos nuestros usuarios, es necesario
          que los conductores cumplan con estos requisitos
        </label>
        {/* INE + LICENCE */}
        <div className="divPickersFile">
          {/* CIRCULACION + POLIZA  */}
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              key={`circulationCard-${formDriver.pickerResetKey}`}
              title={"Tarjeta de circulación vigente"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.circulationCard}
              originalFile={formDriver.originalData.circulationCard}
              file={formDriver.data.circulationCard}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ circulationCard: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ circulationCard: msgError });
              }}
            />
            <VeryPickerImgPdf
              key={`insurensePolicy-${formDriver.pickerResetKey}`}
              title={"Poliza de seguro (EnRed)"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.insurensePolicy}
              originalFile={formDriver.originalData.insurensePolicy}
              file={formDriver.data.insurensePolicy}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ insurensePolicy: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ insurensePolicy: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelDocumentsVehicle>
      {/* PANEL DOCUMENTS DRIVER */}
      <styles.PanelDocumentsDriver
        isActiveStep={formDriver.value.stepSelected === 3}
      >
        {/* WARNING TEXT */}
        <label className="txtWarning">
          Por cuestiones de seguridad para todos nuestros usuarios, es necesario
          que los conductores cumplan con estos requisitos
        </label>
        {/* INE + LICENCE */}
        <div className="divPickersFile">
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              key={`ine-${formDriver.pickerResetKey}`}
              title={"INE"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.ine}
              originalFile={formDriver.originalData.ine}
              file={formDriver.data.ine}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ ine: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ ine: msgError });
              }}
            />
            <VeryPickerImgPdf
              key={`driverLicence-${formDriver.pickerResetKey}`}
              title={"Licencia de manejo"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.driverLicence}
              originalFile={formDriver.originalData.driverLicence}
              file={formDriver.data.driverLicence}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ driverLicence: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ driverLicence: msgError });
              }}
            />
          </div>
          {/* DOMICILIO*/}
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              key={`address-${formDriver.pickerResetKey}`}
              title={"Comprobante de domicilio"}
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.address}
              originalFile={formDriver.originalData.address}
              file={formDriver.data.address}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ address: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ address: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelDocumentsDriver>
    </styles.DivMain>
  );
};

export default ModalDriver;
